import type { ReactNode } from "react";

/**
 * A section page's head: the title with its tabs beside it, so the tabs stand still from one pane to the next whatever
 * action a pane has, and that action at the end of the head (on the next line, at its end, where there is no room).
 */
export function PanelHead({
  className,
  action,
  children,
}: {
  className: string;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 ${className}`}>
      <div className="flex w-full flex-wrap items-center gap-x-6 gap-y-3 sm:w-auto">{children}</div>
      {action}
    </div>
  );
}
